import React from 'react';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SortIcon from '@material-ui/icons/Sort';
import CustomMenu from 'components/CustomMenu';
import { StyledButton, StyledTypography } from 'styles/common';

import { StyledIcon } from 'constants/icons';

import ClearSortListIem from './ClearSortListIem';
import HeaderSortOption from './HeaderSortOption';
import {
  DEPARTMENT_SORT_OPTION,
  DUE_ON_SORT_OPTION,
  LAST_ACTIVITY_DATE_SORT_OPTION,
  OWNER_SORT_OPTION,
  PRIMARY_POD_SORT_OPTION,
} from './sortDropdownOptions';

const items = [
  DEPARTMENT_SORT_OPTION,
  PRIMARY_POD_SORT_OPTION,
  DUE_ON_SORT_OPTION,
  OWNER_SORT_OPTION,
  LAST_ACTIVITY_DATE_SORT_OPTION,
];

export default function GoalSortDropdown({ createSortHandler, orderBy, order, orderByDispatch }) {
  const isAnyOptionSelected = items.some((option) => option.key === orderBy);
  return (
    <CustomMenu
      icon={
        <StyledButton
          startIcon={
            <StyledIcon color={isAnyOptionSelected ? 'primary' : 'textSecondary'} size="header">
              <SortIcon />
            </StyledIcon>
          }
          rightGutter={1}
          leftGutter={-1}
          variant="text"
          endIcon={
            <StyledIcon color={isAnyOptionSelected ? 'primary' : 'textSecondary'} size="header">
              <ArrowDropDownIcon />
            </StyledIcon>
          }
        >
          <StyledTypography color={isAnyOptionSelected ? 'primary' : 'textSecondary'} variant="body2">
            Sort
          </StyledTypography>
        </StyledButton>
      }
    >
      {items.map(({ key, label }) => (
        <HeaderSortOption optionKey={key} createSortHandler={createSortHandler} order={order} orderBy={orderBy}>
          <HeaderSortOption.Select />
          <HeaderSortOption.SortLabel>{label}</HeaderSortOption.SortLabel>
          <HeaderSortOption.SortLabelIcons />
        </HeaderSortOption>
      ))}
      <ClearSortListIem orderByDispatch={orderByDispatch} />
    </CustomMenu>
  );
}
